module.exports = __webpack_public_path__ + "static/media/AdviseeDetails.fe03bd73.svg";